'use strict';
module.exports = function googlePhotosToMindmupMetadata(url, svcMetaData)  {
	const metaData = {
		remoteUrl: url,
		original: svcMetaData.url,
		parentId: svcMetaData.parentId,
		id: svcMetaData.id,
		service: 'googlePhotos'
	};
	return {
		url: url,
		metaData: metaData
	};
};
